module.exports = __webpack_public_path__ + "static/media/smoking.56c18691.svg";